var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _radialGradient5, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _radialGradient6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "none",
    viewBox: "0 0 80 80",
    width: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#ffcb4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd748"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 53.6692,
    x2: 34.6268,
    xlinkHref: "#a",
    y1: 39.2608,
    y2: 40.0249
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 33.1154,
    x2: 32.7325,
    xlinkHref: "#a",
    y1: 65.6657,
    y2: 55.6521
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 30.6742,
    x2: 45.0193,
    xlinkHref: "#a",
    y1: 27.9693,
    y2: 48.4791
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 20.2932,
    x2: 57.0336,
    y1: 19.7978,
    y2: 22.5495
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3118,
    stopColor: "#ffbc47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8900"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbc47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa754"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 19.5935,
    x2: 67.8399,
    xlinkHref: "#f",
    y1: 52.4637,
    y2: 52.4637
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbc47",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c86f34"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 11.8141,
    x2: 107.13,
    xlinkHref: "#h",
    y1: 52.5362,
    y2: 55.5726
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 26.959,
    x2: 42.722,
    xlinkHref: "#h",
    y1: 64.9917,
    y2: 56.4499
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 45.0161,
    x2: 58.1604,
    y1: 52.8643,
    y2: 51.1381
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#643800",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 21.6881,
    x2: 24.5391,
    xlinkHref: "#f",
    y1: 23.8457,
    y2: 71.0529
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#ffbc47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd748"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 65.3286,
    x2: 46.6765,
    xlinkHref: "#m",
    y1: 39.006,
    y2: 39.006
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 65.3285,
    x2: 46.6661,
    xlinkHref: "#m",
    y1: 58.7184,
    y2: 58.7184
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 65.3286,
    x2: 46.6765,
    xlinkHref: "#m",
    y1: 67.5521,
    y2: 67.5521
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 44.162,
    x2: 53.8772,
    xlinkHref: "#a",
    y1: 39.0984,
    y2: 38.877
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 61.1514,
    x2: 51.2483,
    xlinkHref: "#a",
    y1: 58.8499,
    y2: 58.8499
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 61.1514,
    x2: 51.2483,
    xlinkHref: "#a",
    y1: 67.5527,
    y2: 67.5527
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#fba23b",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fba23b"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 49.0629,
    x2: 43.779,
    xlinkHref: "#t",
    y1: 38.8702,
    y2: 38.8702
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    gradientUnits: "userSpaceOnUse",
    x1: 48.1134,
    x2: 42.0368,
    y1: 39.0229,
    y2: 39.0229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#ffbc47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e89043"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbe07a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd748",
    stopOpacity: 0
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(6.80152853 2.96093237 -1.37472316 3.15786301 33.4032 61.7573)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#w"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(6.34307776 .22451791 -.14735822 4.16316289 55.8467 39.0525)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbe07a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd748"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(6.81632693 -.00647248 .00348916 3.67451834 55.5394 59.5052)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#w"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(6.24090723 -.00587757 .00367862 3.90601827 53.1813 67.7665)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#w"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 49.6959,
    x2: 42.0377,
    xlinkHref: "#t",
    y1: 58.6129,
    y2: 58.6129
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#ffbc47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fba23b"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 48.068,
    x2: 43.9428,
    xlinkHref: "#C",
    y1: 58.3447,
    y2: 58.3447
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 49.4205,
    x2: 40.4645,
    xlinkHref: "#t",
    y1: 67.6029,
    y2: 65.9582
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 48.4945,
    x2: 44.7089,
    xlinkHref: "#C",
    y1: 67.3101,
    y2: 67.3101
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 54.529,
    x2: 56.9364,
    xlinkHref: "#h",
    y1: 37.8317,
    y2: 49.4826
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 56.3577,
    x2: 53.7311,
    xlinkHref: "#h",
    y1: 60.8509,
    y2: 51.3741
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 65.3287,
    x2: 46.6766,
    xlinkHref: "#m",
    y1: 49.6691,
    y2: 49.6691
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: 45.924,
    x2: 60.2119,
    y1: 49.1486,
    y2: 49.6705
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#ffcb4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7382,
    stopColor: "#ffd748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcb4b"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientUnits: "userSpaceOnUse",
    x1: 51.4997,
    x2: 40.825,
    xlinkHref: "#t",
    y1: 49.4764,
    y2: 49.4764
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "L",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(6.97153359 -.33316671 .21867883 4.57586769 57.6977 49.4978)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#w"
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 46.5377,
    x2: 43.1673,
    xlinkHref: "#C",
    y1: 49.4637,
    y2: 49.4637
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse",
    x1: 55.414,
    x2: 57.4413,
    xlinkHref: "#h",
    y1: 48.4361,
    y2: 61.3219
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 54.0091,
    x2: 59.2033,
    xlinkHref: "#h",
    y1: 58.4048,
    y2: 69.6743
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 52.9748,
    x2: 53.735,
    xlinkHref: "#h",
    y1: 68.2908,
    y2: 75.4145
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientUnits: "userSpaceOnUse",
    x1: 53.1541,
    x2: 53.1541,
    xlinkHref: "#h",
    y1: 67.2101,
    y2: 62.057
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    gradientUnits: "userSpaceOnUse",
    x1: 18.3641,
    x2: 2.21357,
    y1: 52.9841,
    y2: 77.3875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c86f34",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c86f34"
  }))), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 17.2977,
    x2: 19.9585,
    xlinkHref: "#h",
    y1: 58.3816,
    y2: 70.254
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientUnits: "userSpaceOnUse",
    x1: 18.9089,
    x2: 18.5287,
    xlinkHref: "#h",
    y1: 60.6097,
    y2: 75.142
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "U",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(1.26876167 6.57091997 -3.85468103 .74429023 41.4453 14.4772)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    xlinkHref: "#w"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m39.7928 8c-2.4776 0-3.4196 1.98312-3.2278 5.825.1273 2.5326.9803 9.5933-2.5942 13.1712-3.3337 3.3354-4.3033 3.0391-8.1019 7.3461-3.797 4.3054-6.9619 3.4198-11.3925 3.0391-5.56589-.4773-3.6697 30.4237.2531 29.888 2.7845-.3807 9.1144-1.1404 10.1269-1.1404s7.9561 5.3814 14.0512 5.4459c9.8723.1028 15.3169-1.647 15.3169-1.647l2.8934-6.5664.9681-20.0215-4.6224-9.6316s-6.2025 1.013-7.9745-1.7729c-1.7719-2.7858 1.393-6.2056 1.393-14.1842 0-7.97847-5.8236-9.7513-7.0893-9.7513z",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m54.5697 69.8692-.3758-1.3707c-1.1123-.1182-2.5436.3884-4.4981.373-9.3353-.0721-18.2595-2.7536-22.0887-5.7866-2.5083-1.9862-3.6083-4.6293-5.3802-3.8695-2.1862.9378-8.3887 2.396-10.67-.4927.6382 4.9424 1.7765 8.7367 3.1726 8.5464 2.7845-.3807 9.1144-1.1405 10.1269-1.1405s7.7628 5.2402 14.0512 5.4459c8.1356.2655 15.3614-1.1359 15.3614-1.1359z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m18.4298 39.3324c3.6712 1.013 6.0031-.6631 7.8794-2.944 1.864-2.2655 3.4809-4.2748 8.1647-7.3139 4.6837-3.0392 4.0823-11.3983 3.7019-14.1842-.3805-2.7859-.1274-6.8903 1.617-6.8903-2.4777 0-3.4196 1.98312-3.2279 5.825.1274 2.5327.9803 9.5933-2.5942 13.1712-3.3337 3.3354-4.3033 3.0391-8.1018 7.3461-3.797 4.3055-6.962 3.4198-11.3926 3.0392.0016.9609.2823.9378 3.9535 1.9509z",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m45.4891 31.9356c-1.7719-2.7859 1.393-6.2057 1.393-14.1843 0-7.97847-5.8221-9.7513-7.0893-9.7513-.3329 0-.629.03684-.8944.10744 5.164.32387 8.2737 6.83956 6.4941 13.55796-1.4437 5.452-2.1632 9.8235.1948 12.3868 1.5249 1.6593 4.5579 1.3768 7.8778-.3438-.0015 0-6.204 1.013-7.976-1.7728z",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m45.8373 34.7783c-3.0376 1.0131-10.7099 3.3968-16.5212 8.6693-14.7278 13.3614 10.4168 15.036 15.6099 26.4635.9926 2.1842 6.7947-11.4551 6.7947-11.4551l1.8763-3.1589-5.4217-14.4451z",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m46.2837 35.9355c-3.0376 1.0131-15.4473 8.9671-15.4473 12.8949 0 11.3354 8.5943 5.7406 13.2397 19.116.6428 1.8526 2.9149 3.4106 2.9149 3.4106 1.8824-1.5365 4.7313-12.9011 4.7313-12.9011l1.8762-3.1588-5.4216-14.4452z",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m53.2948 70.6782 5.8144-6.6508 1.281-27.7836-14.5544-1.4674c-3.3414 1.7989-3.728 4.2594-2.4869 8.2103.5217 1.6623-1.6001 2.1381-1.7366 6.9808-.0951 3.3569 2.1018 3.3722 2.1018 4.3699s-1.0939.9087-1.4575 3.799c-.5185 4.1351 2.9425 4.2149 2.9425 5.099s-1.9223 1.409-1.8041 4.7797c.1503 4.2748-7.7843 3.4106-13.1492-.4789-2.203-1.5978-4.1253-1.762-5.6257-1.3998.0936-.0046.1734-.0077.2332-.0077 1.0125 0 7.8134 5.4459 14.0512 5.4459 7.2949 0 12.3392-.4267 14.3903-.8964z",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m54.6325 36.6094c-4.4935 0-6.9619 4.3929-5.2529 7.7682s-3.1649 7.8435-2.6587 10.043c.5063 2.1996 1.393 7.7667 2.088 8.6877.6965.9209-1.1399 3.0099-1.1399 3.0099l5.6963.6969 5.3158-2.3454-.1902-16.0813.5691-10.0691z",
    fill: "url(#k)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m25.869 34.3424c-2.4669 2.7966-4.6669 3.4029-7.12 3.3799.7073 1.142 1.1997 2.3899 1.1491 3.6102-.1335 3.1988.5707 7.142 1.1092 3.0407.4096-3.1236 2.5267-6.984 5.0734-10.2687-.069.0783-.1381.155-.2117.2379z",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m58.0368 33.5827c-5.3127-.2026-14.8643-.5035-15.0776 5.0653-.1534 4.0383 2.7093 5.363 7.1369 5.5318 4.4275.1689 6.6413.2533 8.4746.3224 1.8333.069 7.6017.0353 7.6585-4.8412.0706-6.0921-8.1924-6.0783-8.1924-6.0783z",
    fill: "url(#n)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m49.2984 53.7131c-1.4237-.0415-5.6534 1.0253-6.0492 3.713-.3114 2.1136.7671 4.8442 4.4475 5.4889 4.6623.8165 12.4312 1.2448 15.3338.1581 1.2963-.4851 2.427-1.8435 2.4868-3.9018.0599-2.0584-1.4681-4.832-4.7896-4.9287-3.3214-.0951-5.0519-.0445-6.945-.2686-2.2767-.2671-3.346-.2272-4.4843-.2609z",
    fill: "url(#o)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m47.8149 63.1064c-1.614 0-3.6084 1.4245-3.6084 3.799s.6168 4.132 4.0824 4.7966c3.4656.6647 9.0192.0952 11.1072-.5694 1.6277-.5188 2.2307-2.0415 2.2307-4.5587 0-2.5173-1.5649-2.9579-3.2739-2.9579s-3.7832.3116-4.9676.2502c-3.3076-.1749-3.9565-.7598-5.5704-.7598z",
    fill: "url(#p)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m57.5844 34.7063c-4.6392-.1766-12.9803-.4452-13.1476 3.957-.1212 3.1926 2.3826 4.2486 6.2486 4.396 3.866.1473 14.0374.333 14.0712-3.5211.0414-4.8166-7.1722-4.8319-7.1722-4.8319z",
    fill: "url(#q)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m49.7264 54.8483c-1.2396-.0353-4.7098.2594-5.0427 2.8273-.2256 1.7376.675 3.9694 3.8798 4.502 4.0609.6754 10.8234 1.0376 13.3501.152 1.1276-.3961 2.111-1.5058 2.1586-3.1927.0491-1.6869-1.505-3.7545-4.3953-3.8389-2.8904-.0844-4.4291.1842-6.0783-.003-1.9821-.2226-2.8812-.4191-3.8722-.4467z",
    fill: "url(#r)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m48.5052 63.9727c-1.3961 0-3.1204 1.1465-3.1204 3.0591 0 1.9125.5339 3.3277 3.5316 3.8618 2.9977.5342 7.8011.0768 9.6083-.4589 1.4068-.4175 1.93-1.6439 1.93-3.6715 0-2.0277-1.3547-2.3807-2.8336-2.3807s-3.2723.2517-4.2971.2011c-2.8627-.1397-3.4242-.6109-4.8188-.6109z",
    fill: "url(#s)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m47.6538 38.6656c.1151-3.033 2.5329-4.4866 5.5874-5.1558-4.8756.1136-10.1254 1.0253-10.2834 5.1374-.1534 4.0384 2.7093 5.363 7.1368 5.5318.4879.0185.9466.0369 1.3823.0522-2.4853-.7275-3.9443-2.3684-3.8231-5.5656z",
    fill: "url(#u)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m48.071 34.0586c-2.8367.6201-5.0121 1.9616-5.1118 4.5879-.1273 3.3569 1.8318 4.8381 5.0396 5.34-6.5077-2.5986-4.1728-8.9993.0722-9.9279z",
    fill: "url(#v)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m40.5169 65.9662c-.7502 1.7237-4.3202 1.8327-7.9745.241-3.6543-1.5902-6.0077-4.2778-5.2575-6.003.7502-1.7238 4.3201-1.8327 7.9745-.241 3.6528 1.5917 6.0077 4.2793 5.2575 6.003z",
    fill: "url(#x)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m62.0165 39.4799c-.0368 2.3301-3.1511 3.4352-6.5585 3.6424-2.786.1688-5.8788-1.8035-5.799-4.0798s.4848-4.2932 6.2746-4.0921c3.412.1182 6.1182 2.2532 6.0829 4.5295z",
    fill: "url(#y)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m62.6347 59.9617c-.0199 3.2264-3.5653 2.6078-6.9727 2.8319-4.3201.2855-7.1844-1.0606-7.1859-3.3385-.0031-2.2778 1.64-3.9371 7.4345-3.9463 3.4134-.0046 6.7487.3086 6.7241 4.4529z",
    fill: "url(#z)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m59.5113 68.0967c-.0169 2.7506-3.2386 3.1251-6.2915 3.1267-3.053.003-6.3667-1.6163-6.3682-3.558-.0016-1.9417 1.4666-3.3569 6.6474-3.3646 3.0514-.0046 6.0338.2625 6.0123 3.7959z",
    fill: "url(#A)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m47.2105 58.0802c.4848-3.6731 3.3015-3.4582 6.5309-3.8389-3.7173-.2778-5.2775-.3177-5.2775-.3177-.3467-.0338-.7349-.0353-1.1383.0061-1.2074.2656-2.5759.8151-3.389 1.8466-.2761.3929-.5001.8564-.6474 1.4059-.0153.0799-.0307.1612-.0399.2441-.2623 2.1213.7671 4.8442 4.4475 5.4889.5308.0936 1.1031.1811 1.7029.2625.2869.0368.5999.0752.9358.1182.0906.0107.1811.0215.2731.0322-2.0312-.9593-3.7556-2.548-3.3981-5.2479z",
    fill: "url(#B)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m48.1093 53.9001c-.2501-.0077-.5155.0015-.787.0291-1.2181.2686-2.5988.8258-3.4073 1.8742-.267.3868-.4818.8442-.626 1.3799-.0153.0798-.0261.1596-.0399.2425-.3728 2.089.6613 4.5511 3.8768 5.3661-5.4861-3.0269-3.145-8.8888.9834-8.8918z",
    fill: "url(#D)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m51.3034 63.6672c-1.6216-.2379-2.2874-.5617-3.4871-.5617-1.6139 0-3.6083 1.4244-3.6083 3.7989 0 .8626.0829 1.6424.3513 2.3193.2731.5587.6705 1.0821 1.2151 1.5242.5983.4175 1.4114.7413 2.5144.9531.741.1428 1.5787.2272 2.4562.2687-1.6937-.9839-4.5625-1.5135-3.9612-4.8074.6643-3.6378 2.8351-3.1466 4.5196-3.4951z",
    fill: "url(#E)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m47.7442 63.1084c-1.6001.0414-3.5362 1.4582-3.5362 3.7974 0 2.175.5201 3.8327 3.2724 4.6063-4.2987-2.7629-2.9195-7.4244.2638-8.4037z",
    fill: "url(#F)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m66.2293 39.661c.0062-.5464-.0552-1.0422-.1703-1.495.428 1.9033-1.2672 3.7944-5.7607 4.7122-2.9778.6079-10.8863 1.3677-16.3586-.8058 1.1813 1.4275 3.3552 1.9985 6.1565 2.1059 4.4276.1689 6.6413.2533 8.4747.3224 1.8333.0721 7.6001.0368 7.6584-4.8397z",
    fill: "url(#G)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m65.5174 59.0422c-.0062-2.0445-1.5388-4.7046-4.7912-4.7982-3.3214-.0952-5.0519-.0445-6.945-.2686-2.2752-.2686-3.3445-.2287-4.4828-.2609-.8607-.0246-2.9839.2348-4.4276 1.1327 1.6232.5634 4.268 1.4106 7.9899 1.1727 8.918-.574 11.4554.505 12.6567 3.0223z",
    fill: "url(#H)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m47.3854 44.5003c-1.8977-.0384-4.9123 1.079-4.9905 5.0222-.0783 3.9417 3.3689 4.8811 4.8877 4.9118 1.5189.0307 6.8285.3929 13.3778.5234 6.5493.1304 7.4268-3.3861 7.4636-5.228.0368-1.8434-1.1307-5.1757-5.0703-5.2555-11.3911-.2287-15.6683.0261-15.6683.0261z",
    fill: "url(#I)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m48.4039 45.6439c-1.6507-.0322-4.2679.8243-4.3278 3.8649-.0613 3.0422 2.9379 3.7729 4.2573 3.799 1.3209.0261 5.9371.3162 11.6303.4297 5.6932.1136 6.4496-2.597 6.4772-4.0199.0291-1.4214-.1672-3.9939-3.593-4.063-9.8998-.1964-14.444-.0107-14.444-.0107z",
    fill: "url(#J)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m46.468 49.142c.1902-4.0475 3.0146-4.0598 6.2026-4.7582-3.728.023-5.2852.1151-5.2852.1151-1.8977-.0384-4.9123 1.0791-4.9905 5.0223-.0783 3.9416 3.3689 4.881 4.8877 4.9117.5477.0108 1.5894.0645 3.0008.1351-2.1048-.8672-3.955-2.4482-3.8154-5.426z",
    fill: "url(#K)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m64.7888 49.5613c.1319 3.2233-3.4472 3.8296-6.8576 3.9923s-7.2013-1.561-7.3102-3.8358c-.109-2.2747 1.4543-4.0091 7.2411-4.29 3.4104-.1643 6.7579-.0077 6.9267 4.1335z",
    fill: "url(#L)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m47.0308 44.5068c-1.8962.1013-4.5625 1.3109-4.6362 5.0146-.0751 3.7483 3.0361 4.7813 4.6485 4.8995-6.2394-2.5188-4.1943-9.5426-.0123-9.9141z",
    fill: "url(#M)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m68.113 49.3311c-.8223 5.8326-16.2358 4.7643-24.5647 3.5118 1.1246 1.2049 2.7968 1.5702 3.7341 1.5902 1.5188.0307 6.8285.3929 13.3778.5234 6.5492.1305 7.4268-3.386 7.4636-5.2279.0015-.1259-.0016-.2594-.0108-.3975z",
    fill: "url(#N)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m60.3918 62.3194c-2.9855.1321-10.8848 1.1144-16.644-1.9723.6428 1.1941 1.887 2.2087 3.9474 2.5694 4.6622.8166 12.4311 1.2449 15.3337.1581 1.2964-.485 2.4271-1.8434 2.4869-3.9017-.1918 1.7897-1.8962 3.0038-5.124 3.1465z",
    fill: "url(#O)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m61.3982 68.8008c-1.956 1.4888-5.3373 2.3684-10.2159 1.5441-3.013-.5096-5.078-.683-6.4357-.7199.5431.9824 1.5909 1.7038 3.5423 2.0783 3.4657.6646 9.0193.0952 11.1072-.5695 1.0724-.3438 1.6983-1.1235 2.0021-2.333z",
    fill: "url(#P)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m44.8479 64.7688c3.6144-1.317 5.3864.637 9.254.637 4.0164 0 5.931-1.6224 7.3577-.0798-.4479-1.4229-1.7305-1.71-3.1066-1.71-1.7091 0-3.7832.3116-4.9691.2502-3.3076-.1734-3.955-.7598-5.569-.7598-1.0447 0-2.2475.5971-2.967 1.6624z",
    fill: "url(#Q)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m14.7312 67.2694c2.7844-.3807 9.1143-1.1404 10.1268-1.1404-9.1803-6.5649-5.0979-20.5281-1.7121-27.5902.4756-.9916.7686-1.8051.9267-2.4958-3.0545 2.33-5.8804 1.6577-9.5961 1.3384-5.56589-.4773-3.6682 30.4237.2547 29.888z",
    fill: "url(#R)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m20.5193 60.9254c-.9496-1.2663-.1273 1.4566.6336 3.4198.6459 1.67-4.3078.683-8.0987 1.0929.4955 1.2233 1.0616 1.9156 1.6768 1.8311 2.7845-.3806 9.1144-1.1404 10.1269-1.1404-1.4283-1.2141-3.3905-3.9371-4.3386-5.2034z",
    fill: "url(#S)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m24.8563 66.131c-.787-.6707-1.7366-1.8004-2.5912-2.8917 0 0-4.6085 2.3591-9.55 1.2494.5692 1.805 1.2534 2.8856 2.0143 2.7812 2.786-.3791 9.1144-1.1389 10.1269-1.1389z",
    fill: "url(#T)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m42.3138 19.8899c-1.8042.3899-3.2662-2.1028-4.0916-5.0115-.675-2.3791.2424-5.40906 2.0143-5.74982 1.772-.34228 3.4074-.35764 4.3846 4.68462.5738 2.97-.5431 5.696-2.3073 6.0767z",
    fill: "url(#U)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#804b24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.7443 63.108c-.9926.1044-1.8916.637-2.5099 1.3692-.6275.7383-.9205 1.7022-.856 2.6708.0061.9746.1534 1.9708.7057 2.7598.5477.7966 1.4681 1.2709 2.3963 1.604-.9573-.2165-1.9591-.6125-2.6004-1.4521-.6505-.8304-.8008-1.9125-.833-2.9056-.043-1.0161.2807-2.0967.9972-2.8458.6949-.7567 1.6983-1.2202 2.7001-1.2003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.152 54.2734c-.6536.284-1.2565.6723-1.7551 1.1558-.5078.4774-.7778 1.1313-.9634 1.7944l.0015-.0108c-.2393 1.2095-.0368 2.4973.6735 3.5027.6934 1.0192 1.8195 1.6854 3.0161 2.0752-1.2319-.2379-2.473-.838-3.2524-1.9079-.385-.5265-.652-1.142-.7809-1.7851-.1304-.6431-.0705-1.3154.0491-1.9432l.0031-.0108c.1948-.6968.5416-1.3952 1.1138-1.8664.5477-.4866 1.2196-.7859 1.8947-1.0039z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.0309 44.5049c-1.1736.1335-2.3089.6216-3.1173 1.4428-.8116.8212-1.2504 1.9524-1.3209 3.1051-.1182 1.1481.0675 2.3469.7241 3.3001.6474.9562 1.7059 1.5978 2.8381 1.9294-1.1598-.2118-2.3135-.7844-3.0468-1.7805-.7486-.9885-.9465-2.2824-.8468-3.4766.0982-1.2003.5691-2.4252 1.4743-3.2586.8959-.8427 2.1125-1.2494 3.2953-1.2617z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.0711 34.0586c-1.2549.3438-2.5022.8181-3.4917 1.6332-.9972.8104-1.5372 2.0614-1.4543 3.343-.0169 1.2725.3988 2.571 1.3653 3.4137.9527.8534 2.2383 1.2679 3.5071 1.538-1.2872-.1519-2.6265-.4743-3.6743-1.3461-1.0724-.8596-1.528-2.284-1.5295-3.6025-.0691-1.34.5339-2.7429 1.6262-3.5441 1.0708-.8212 2.3702-1.208 3.6512-1.4352z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.7493 60.3457c.8637 1.4965 2.5236 2.2717 4.1636 2.4927 1.6692.2579 3.3506.4344 5.0366.5418 1.683.1428 3.3721.2318 5.0612.2257.8437-.0108 1.689-.0323 2.5282-.1152.8392-.0675 1.686-.1535 2.493-.419-1.597.6002-3.3291.6953-5.0166.7552-1.6968.043-3.3951-.0046-5.0888-.1151-1.6906-.1459-3.3766-.3592-5.0489-.6554-.8407-.1382-1.6783-.3991-2.4147-.8473-.7333-.4528-1.3347-1.1051-1.7136-1.8634z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.5483 52.8428c.6474.6446 1.4805 1.0698 2.3503 1.2863.8653.2594 1.7751.2026 2.6894.244l5.46.1581 5.457.2686c1.8103.1105 3.6528.1351 5.3879-.4589-1.6906.7214-3.5899.7797-5.3925.6799l-5.46-.158-5.457-.2702c-.8975-.0614-1.841-.0184-2.7292-.3085-.8776-.2748-1.6983-.7583-2.3059-1.4413z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.0535 44.4734c-1.3055.0031-2.6126.0399-3.9182.0277l-3.9166.0076-3.9152.0538c-1.304.0076-2.6111.0153-3.9105.0675h-.0107c-1.2841-.0215-2.6142.4175-3.5393 1.3369-.9435.9102-1.3884 2.2349-1.4482 3.5549.0107-.6616.0813-1.3293.2838-1.9693.2056-.6385.5569-1.2356 1.034-1.7161.9512-.9777 2.3227-1.4627 3.6758-1.4658h-.0107c2.6157-.1581 5.2283-.1596 7.841-.1182 2.6142.0292 5.2253.0783 7.8348.221z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.046032a4b2ef8ca9d9fe9bd8982baa6c.svg";
export { ForwardRef as ReactComponent };